import '../App.css';
import { motion } from 'framer-motion';

const allNewsItems = [
  {
    id: 1,
    title: "Hubble Heavy Industries Inc. Incorporates in New Brunswick",
    date: "2025.12.23",
    category: "HHI",
    url: ""
  },
  {
    id: 1,
    title: "Climatech Innovations Inc. Acquires 75 Acres in Southern New Brunswick",
    date: "2025.06,15",
    category: "CTI",
    url: ""
  },
];

function NewsCard({ item, index }) {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ 
        delay: index * 0.1,
        duration: 0.5,
        ease: [0.4, 0, 0.2, 1]
      }}
      whileHover={{ y: -2 }}
      onClick={() => item.url && window.open(item.url, '_blank')}
      className={`group relative ${item.url ? 'cursor-pointer' : 'cursor-default'}`}
    >
      <motion.div 
        className="absolute inset-0 bg-gradient-to-r from-white/10 to-white/5 rounded-xl opacity-0 
                  group-hover:opacity-100 transition-opacity duration-500"
        whileHover={{ scale: 1.02 }}
        transition={{ duration: 0.3 }}
      />
      <div className="relative border border-white/10 rounded-xl p-6 backdrop-blur-sm
                    hover:border-white/20 transition-all duration-500
                    bg-gradient-to-r from-white/5 to-transparent">
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: index * 0.1 + 0.2 }}
          className="flex justify-between items-start mb-4"
        >
          <div className="text-xs font-mono opacity-50">[{item.date}]</div>
          <motion.div 
            className="text-xs font-mono text-white/70"
            whileHover={{ scale: 1.05, color: 'rgba(255, 255, 255, 0.9)' }}
          >
            {item.category}
          </motion.div>
        </motion.div>
        <motion.h2 
          className="text-2xl font-bold mb-3 bg-clip-text text-transparent 
                     bg-gradient-to-r from-white to-white/80 group-hover:from-white group-hover:to-white
                     transition-all duration-500"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: index * 0.1 + 0.3 }}
        >
          {item.title}
        </motion.h2>
        <motion.p 
          className="text-sm leading-relaxed opacity-70 group-hover:opacity-90 transition-opacity duration-500"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.7 }}
          transition={{ delay: index * 0.1 + 0.4 }}
        >
          {item.summary}
        </motion.p>
{item.url && (
          <motion.div 
            className="mt-4 flex items-center gap-2 text-xs font-mono text-white/70 
                      group-hover:text-white transition-colors duration-500"
            whileHover={{ x: 5 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <span>Visit Site</span>
            <span className="group-hover:translate-x-1 transition-transform duration-500">→</span>
          </motion.div>
        )}
      </div>
    </motion.div>
  );
}

function News() {
  return (
    <div className="fixed inset-0 overflow-y-auto overflow-x-hidden">
      <div className="min-h-screen pt-20 pb-32 px-4">
        <div className="container mx-auto">
          <motion.h1 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="font-mono text-white/90 text-center text-4xl font-bold uppercase tracking-tight mb-8"
          >
            Updates
          </motion.h1>
          <div className="max-w-4xl mx-auto grid gap-6">
            {allNewsItems.map((item, index) => (
              <NewsCard 
                key={item.id} 
                item={item} 
                index={index}
              />
            ))}
          </div>
          
          {/* Scroll indicator at bottom */}
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8 }}
            className="flex justify-center mt-12 pb-8"
          >
            <div className="font-mono text-xs text-white/40">
              [ End of Updates ]
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default News; 